import { trackLeanAnalytics } from "@/shared";
import {
  deviceUUIDEvent,
  pageViewEvent,
  storeCountryEvent,
} from "@dafiti/analytics-sdk";

export const pageView = ({ title }: { title: string }) => {
  pageViewEvent({
    page_location: window.location.href,
    page_path: window.location.pathname,
    page_title: title,
  });

  trackLeanAnalytics("page_view", {
    page_path: window.location.pathname,
    page_title: title,
  });
};

export const storeCountry = (country: string) => {
  storeCountryEvent({ store_country: country });
};

export const deviceUUID = () => {
  deviceUUIDEvent();
};
